"use client";

import { Link } from "react-router-dom";

const posts = [
  {
    category: "Quantity Surveyor",
    post: (
      <span className="text-sm">
        Applicants must have 3 years' post graduate experience with a
        Contractor, Subcontractor or a Quantity Surveying Consultant.
      </span>
    ),
  },
  {
    category: "Senior Quantity Surveyor",
    post: (
      <span className="text-sm">
        Applicants must have 6 years post graduate experience either with a
        Contractor, Subcontractor or with a Quantity Surveying Consultant.
        Corporate membership of RICS or ICES is preferred
      </span>
    ),
  },
  {
    category: "Planning Engineers",
    post: (
      <span className="text-sm">
        Applicants must have 3 years post graduate experience either with a
        Contractor, Subcontractor
      </span>
    ),
  },
  {
    category: "Senior Planning Engineers",
    post: (
      <span className="text-sm">
        Applicants must have 6 years post graduate experience either with a
        Contractor, Subcontractor. Corporate membership of MHKIE CIOB MICE is
        preferred
      </span>
    ),
  },
];

function CareersPage(props: { yScroll?: number }) {
  return (
    <div className="full-screen py-24 px-2 md:px-[5%]">
      <div className="container">
        <div className="text-2xl text-black font-medium mb-4">Careers</div>
        <div className="mt-4">
          Search our current opportunities around the world.
        </div>
        <div className="w-full mt-8 [&>tr]:border-0">
          {posts.map((post, index) => (
            <div
              className="grid gap-2 grid-cols-1 md:grid-cols-3 p-2"
              key={`post-${index}`}
            >
              <div className="font-bold">{post.category}</div>
              <div>{post.post}</div>
              <div>
                <Link to={"mailto:wilson.wws55@gmail.com"}>Apply</Link>
              </div>
              <hr className="w-full md:col-span-3" />
            </div>
          ))}
        </div>
        <div className="w-full mt-8 [&>tr]:border-0 text-sm [&>*]:mt-4">
          <div>
            A command of spoken and written English and Cantonese is required;
            Mandarin would be an advantage
          </div>
          <div>
            Please write to us enclosing your Curriculum Vitae and a covering
            letter, outlining your career aspirations and how you think you can
            contribute to Wilson Wong & Associates​
          </div>
        </div>
      </div>
    </div>
  );
}

export default CareersPage;
